<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="md-layout-item md-size-33">
      <invite-token-handler />
    </div>
  </div>
</template>

<script>
import InviteTokenHandler from '../../components/auth/InviteTokenHandler';

export default {
  name: 'accept-invite',
  components: {
    InviteTokenHandler,
  },
};
</script>

<style>
</style>
